import {
  Box,
  Button,
  Divider,
  Flex,
  List,
  Paper,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import { GoGear } from 'react-icons/go';
import { useWorkerStore } from '@worker/stores';

interface WelcomeProps {
  handleConfigure: () => void;
  handleGetInNetwork: () => void;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent) => void;
}

function Welcome({
  handleConfigure,
  handleGetInNetwork,
  style,
  onClick,
}: WelcomeProps) {
  const { isInNetwork } = useWorkerStore();
  return (
    <Paper
      style={style}
      shadow="xl"
      withBorder
      p="md"
      mb="md"
      radius="md"
      w="100%"
      maw={485}
      onClick={onClick}
    >
      <Title order={4} ta="center">
        Welcome to your personal curated jobs!
      </Title>
      <Divider my="md" />
      <Stack>
        <Text>
          With My Jobs, personalize your job notifications to your liking, and
          see them in one list.{' '}
          <Text fw="bold">
            Click the “CONFIGURE” button below to get started.
          </Text>
        </Text>
        <Stack>
          <Flex justify="center">
            <Button
              variant="light"
              fw="bold"
              onClick={handleConfigure}
              rightSection={<GoGear size={20} />}
            >
              Configure
            </Button>
          </Flex>

          {!isInNetwork() && (
            <>
              <Box>
                <Text>
                  Want to get a{' '}
                  <Text fw="bold" component="span">
                    new job alerts faster?
                  </Text>
                </Text>
                <Text>Join In-Network today!</Text>
                <Text>Here are the perks with In-Network:</Text>
              </Box>
              <List withPadding>
                <List.Item>
                  <Text fw="bold">Receive new job alerts faster</Text>
                </List.Item>
                <List.Item>
                  <Text fw="bold">Be at the Top of Lists</Text>
                </List.Item>
                <List.Item>
                  <Text fw="bold">In-Network Badge</Text>
                </List.Item>
                <List.Item>
                  <Text fw="bold">Custom TH Profile URL</Text>
                </List.Item>
              </List>

              <Text>
                Show companies you&apos;re committed and become more desirable
                for opportunities.
              </Text>
              <Text>
                <Text fw="bold">
                  Click on the &quot;GET IN-NETWORK&quot; button below to join
                  today.
                </Text>
              </Text>

              <Flex justify="center">
                <Button fw="bold" onClick={handleGetInNetwork}>
                  Get in-network
                </Button>
              </Flex>
            </>
          )}
        </Stack>
      </Stack>
    </Paper>
  );
}

export default Welcome;
